import React, { useState } from "react";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { Button, IconButton } from "@material-tailwind/react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";

export function Paginate({
  isLoading,
  currentPage,
  newsPerPage,
  totalNews,
  paginate,
}) {
  const [active, setActive] = useState(currentPage);
  const getItemProps = (index) => ({
    variant: active === index ? "filled" : "text",
    color: active === index ? "gray" : "#000",

    onClick: () => {
      isLoading = true;
      setActive(index);
      paginate(index);
      scrollToTop()

    },
  });
  const next = () => {
    isLoading = true;
    if (active === Math.ceil(totalNews / newsPerPage)) return;
    setActive(active + 1);
    paginate(active + 1);
  };

  const prev = () => {
    isLoading = true;
    if (active === 1) return;
    setActive(active - 1);
    paginate(active - 1);

  };
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  return (
    <div className="flex items-center justify-center gap-2">
      <Button
        variant="text"
        className="flex w-8 h-8 cursor-pointer bg-[#1e81f9] justify-center items-center rounded-lg"
        onClick={prev}
        disabled={active === 1}
      >
        <FaAngleLeft className="h-5 w-5 fill-white" />
      </Button>
      <div className="flex items-start gap-2">
        {Array.from({ length: Math.ceil(totalNews / newsPerPage) }).map(
          (_, index) => (
            <IconButton className="flex w-8 h-8 cursor-pointer bg-[#1e81f9] justify-center items-center rounded-lg" key={index} {...getItemProps(index + 1)}>
              <span className="">{index + 1}</span>
            </IconButton>
          )
        )}
      </div>
      <Button
        variant="text"
        className="flex w-8 h-8 cursor-pointer bg-[#1e81f9] justify-center items-center rounded-lg"
        onClick={next}
        disabled={active === Math.ceil(totalNews / newsPerPage)}
      >
        <FaAngleRight className="h-5 w-5 fill-white" />
      </Button>
    </div>
  );
}